import { render } from "./RegistrationFirstStepPage.vue?vue&type=template&id=11b3d87a&scoped=true"
import script from "./RegistrationFirstStepPage.vue?vue&type=script&lang=js"
export * from "./RegistrationFirstStepPage.vue?vue&type=script&lang=js"

import "./RegistrationFirstStepPage.vue?vue&type=style&index=0&id=11b3d87a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b3d87a"]])

export default __exports__